import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/partner/opportunityOverview";

/**
 * 商机概况页接口
 */
export default {
    /** 查询商机概况，一次返回 KPI + 阶段分布 + 金额趋势 */
    overview: (data) => axios.get({url: `${PREFIX_URI}/overview`, data}),
    /** 预警统计：7天未联系 / 15天未联系 / 预计成交剩余7天 / 预计成交剩余15天 */
    warnStat: (data) => axios.get({url: `${PREFIX_URI}/warnStat`, data}),
    /** 预警商机列表，点预警卡片后的弹框用，分页 */
    queryWarnList: (data) => axios.get({url: `${PREFIX_URI}/queryWarnList`, data}),
}
